import { createReducer } from 'redux-starter-kit';
import { SET_CIP_CATEGORIES, SET_MPS_FIRMS } from './actions';

interface CIPState {
  cip_categories: any[];
  mps_firms: any[];
}

const INITIAL_STATE: CIPState = {
  cip_categories: [],
  mps_firms: []
};

export default createReducer(INITIAL_STATE, {
  [SET_CIP_CATEGORIES]: (state, action) => {
    state.cip_categories = action.payload;
  },
  [SET_MPS_FIRMS]: (state, action) => {
    state.mps_firms = action.payload;
  }
});
